var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.data,"label":"Marque","item-text":"name","return-object":""},on:{"change":function($event){return _vm.update()}},model:{value:(_vm.brand),callback:function ($$v) {_vm.brand=$$v},expression:"brand"}})}
var staticRenderFns = []

export { render, staticRenderFns }